import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';

interface RecallButtonProps {
	onClick: () => void;
	code: PageCode;
}

export const RecallButton = ({ onClick, code }: RecallButtonProps) => {
	const { t } = useLocale(code);

	return (
		<Button
			onClick={onClick}
			aria-label={t('akce.tlacitko.wcag.odvolat-souhlas')}
			nativeType="button"
			color="error"
			size="s"
			type="base"
			isFocusable={false}
			className="-ml-(--spacing-s-nudge)! mt-(--templates-margin-s)! [ md:absolute md:top-(--templates-margin-l) md:right-(--templates-margin-l) md:ml-0! md:mt-0! ]">
			{t('akce.tlacitko.odvolat-souhlas')}
		</Button>
	);
};
